import { Box, Flex, Image, Link } from '@chakra-ui/react';
import { useObtBreakpointValue } from 'src/hooks/useObtBreakpointValue';
import logo from 'src/assets/frontier-lodging-solutions-logo-v1.png';
import logosmall from 'src/assets/small-logo.svg';

export const LogoHeader = () => {
  const showDesktopView = useObtBreakpointValue({ base: false, sm: false, md: true, lg: true, xlTo2xl: true });
  const showMobileView = useObtBreakpointValue({ base: true, sm: true, md: false, lg: false, xlTo2xl: false });

  return (
    <>
      {/* Desktop header */}
      {showDesktopView && (
        <Box position={'fixed'} width={'100%'} zIndex={'sticky'}>
          <Box
            bg={'white'}
            height={'70px'}
            marginBottom={'0px'}
            borderTopWidth={'10px'}
            borderTopColor={'primary.500'}
            borderStyle={'solid'}
            boxSizing='content-box'
            boxShadow={'none'}
            borderBottom={'1px solid rgb(221, 222, 224)'}>
            <Flex
              w={'100%'}
              h={'100%'}
              gap={'24px'}
              paddingEnd={'24px'}
              alignItems={'center'}
              justifyContent={'flex-start'}>
              <Link href='/' paddingLeft={'20px'} paddingRight={'20px'}>
                <Image height={['40px']} src={logo} alt='Frontier Lodging Solutions' />
              </Link>
            </Flex>
          </Box>
        </Box>
      )}

      {/* Mobile header */}
      {showMobileView && (
        <Box position={'fixed'} width={'100%'} zIndex={'sticky'}>
          <Box
            bg={'white'}
            height={'50px'}
            marginBottom={'0px'}
            borderTopWidth={'5px'}
            borderTopColor={'primary.500'}
            borderStyle={'solid'}
            boxSizing='content-box'
            boxShadow={'none'}
            borderBottom={'1px solid rgb(221, 222, 224)'}>
            <Flex w={'100%'} h={'100%'} alignItems={'center'}>
              <Box paddingLeft={'8px'}>
                <Link href='/'>
                  <Image height={['40px']} src={logosmall} alt='Frontier Lodging Solutions' />
                </Link>
              </Box>
            </Flex>
          </Box>
        </Box>
      )}
    </>
  );
};
